import { z, zv } from '@faceup/validation'

export const memberSchema = z.object({
  id: z.uuidv7(),
  name: z.string().nullable(),
  email: zv.email().nullable(),
  // A signed URL our own backend builds, so no user-input URL rules: locally it points at
  // localhost, which has no TLD.
  profileImageUrl: z.string().nullable(),
})
